export const defaultPrimaryCardStyles = {
    "basic" : {
        "name" : "NEW DEALS",
        "sumvalue" : "2.5K",
        "countvalue" : "28",
    },
    "comparison" : {
        "name" : "NEW DEALS (Comparison)",
        "sumvalue" : "1.8K",
        "countvalue" : "17",
    },
};

export const dashboardSortList = [
  {"value": 0, "label" : "None"},
  {"value": 1, "label" : "Ascending"},
  {"value": 2, "label" : "Descending"},
];

export const dashboardFolderPermissionList = [
  {"value" : "Public", "label" : "Public"},
  {"value" : "Private", "label" : "Private"}
];

export const durationWidgetList = [
  {value : "today", label: "Today"},
  {value : "This Week", label: "This Week"},
  {value : "This Month", label: "This Month"},
  {value : "This Quarter", label: "This Quarter"},
  {value : "This Year", label: "This Year"},
  {value : "Last", label: "Last"},
  {value : "Custom", label: "Custom"},
];

export const periodList = [
  {value: "days", label: "day(s)"},
  {value: "weeks", label: "week(s)"},
  {value: "months", label: "month(s)"}
];

export const previousList = {
  "today" : "Yesterday",
  "This Week": "Last Week",
  "This Month" : "Last Month",
  "This Quarter" : "Last Quarter",
  "This Year" : "Last Year"
}

export const compareToList = [
  {value: "prev_period", label: "Previous Period"},
  {value: "Custom", label: "Custom"}
];

export const objectiveList = [
  {value: "positive", label: "Consider increase in value as positive"},
  {value: "negative", label: "Consider increase in value as negative"}
];

export const graphChartSampleData = {
    "1,1" : {
        "type" : 1,
        "dbtype" : 1,
        "name" : "Bar Chart",
        "data" : [
            [
                "All Active Leads by Source",
                "1",
                [
                  [
                    "Facebook Ad",
                    "88000.00"
                  ],
                  [
                    "Google Ad",
                    "22500.00"
                  ],
                  [
                    "WhatsApp",
                    "37000.00"
                  ],
                ]
              ]
        ]
    },
    "1,0" : {
        "type" : 0,
        "dbtype" : 1,
        "name" : "Horizontal Chart",
        "data" : [
            [
                "All Active Leads by Owner",
                "0",
                [
                  [
                    "Employee",
                    "75000.00"
                  ],
                  [
                    "Demo User",
                    "53000.00"
                  ],
                  [
                    "Akhilesh",
                    "17854.00"
                  ],
                ]
              ]
        ]
    },
    "1,2" : {
        "type" : 2,
        "dbtype" : 1,
        "name" : "Pie Chart",
        "data" : [
            [
                "Closed Won by Owner - Last 30 Days",
                "2",
                [
                  [
                    "Demo User",
                    "88000.00"
                  ],
                  [
                    "Kailash",
                    "77300.00"
                  ],
                  [
                    "Nitin",
                    "47000.00"
                  ]
                ]
              ]
        ]
    },
    "1,3" : {
        "type" : 3,
        "dbtype" : 1,
        "name" : "Funnel Chart",
        "data" : [
            [
                "All Active Leads by Stage",
                "3",
                [
                  [
                    "HOT",
                    "2737500.00"
                  ],
                  [
                    "FOLLOW UP",
                    "1086285.00"
                  ],
                  [
                    "NEW",
                    "890170.00"
                  ]
                ]
              ]
        ]
    },
    "0,0" : {
        "type" : 0,
        "dbtype" : 0,
        "name" : "Table Chart",
        "data" : [
            [
                [
                  "First Name",
                  "Record Count"
                ],
                [
                  [
                    "Vinay Shetty",
                    "1"
                  ],
                  [
                    "Madhuri Krishnan",
                    "1"
                  ],
                  [
                    "Khushal",
                    "1"
                  ]
                ]
              ]
        ]
    }
};